import { MembercardWebapp } from '@/type/MemberCard'
import { getDateFnsLocaleLang } from '@/utils'
import currency from 'currency.js'
import { addMonths, format, parse } from 'date-fns'

export const $currency = (number: number | currency) => {
  return currency(number, { precision: 5 })
}

export const useCurrencyDisplay = (num: number | currency) => {
  return currency(num, { precision: 2 }).format({
    separator: ',',
    symbol: '฿',
  })
}

// Function for member calculate
export const formatLocalExpireDate = (expired: Date | null) => {
  if (expired) {
    return format(expired, 'd MMM yyyy', {
      locale: getDateFnsLocaleLang(),
    })
  }
  return ''
}

export function getFormattedPointExpireDate(pointExpireDate: string | null | undefined, t: Function): string {
  if (pointExpireDate) {
    const formatDate = parse(pointExpireDate, 'yyyy-MM-dd', new Date())
    return `${t('membercard.point_expire_date')} : ${format(formatDate, 'd MMM yyyy', {
      locale: getDateFnsLocaleLang(),
    })}`
  }
  return ''
}

export function getMembercardExpireDate(member: MembercardWebapp): Date | null {
  if (member?.expire_date) {
    // case is_max level membercard
    if (member.is_max && member.member_card.min_spending) {
      const renewLap = Math.floor(member.total_spending / member.member_card.min_spending)
      if (renewLap > 0) {
        const formatDate = parse(member.expire_date, 'dd-MM-yyyy HH:mm', new Date())
        return addMonths(formatDate, member.member_card.expire_in * renewLap)
      }
    }
    // case normal expire date
    return parse(member.expire_date, 'dd-MM-yyyy HH:mm', new Date())
  }

  return null
}

export const getMonthNameList = (date: Date): string[] => {
  let monthList: string[] = []
  for (let i = 0; i <= 11; i++) {
    const monthDate = addMonths(date, i)
    const label = format(monthDate, 'MMMM yyyy')
    monthList.push(label)
  }
  return monthList
}
